import { AppColors } from "@/assets/colors";
import { AppSize, IAppStore, ListingStatus, ngStates, PropertyType, pxToRem } from "@/util";
import { Box, Button, Divider, Typography } from "@mui/material";
import React from "react";
import { makeStyles } from "tss-react/mui";
import InputSelect from "../global/select";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { InvestmentStatus, PriceRange } from "@/util/types/investment";
import { setLocation, setPriceRange, setPropertyType, setSearch, setSort, setStatus } from "@/store/propertyfilter";

type props={
  currentPage:string
}
export default function Sortcont({currentPage}:Partial<props>) {
  const propFilter=useSelector((state:IAppStore)=>state.propertyFilter);
  const { location, propertyType, sort,status,priceRange } = propFilter;
   const dispatch=useDispatch();
 
  const appStatus=currentPage==="INVESTMENTS"?InvestmentStatus:ListingStatus;
  const options: { name: string; placeholder: string,value:string ,data:{label:string,value:string}[],handleChange:(e:string)=>void,}[] = [
    { name: "Location", placeholder: "Select Location" ,data:ngStates.map((item) => ({ value: item.name, label: item.name })),value:location,handleChange:(e:string)=>dispatch(setLocation(e))},
    { name: "Property Type", placeholder: "Property Type", data:Object.keys(PropertyType).map(key => ({ label: key, value: key })),  value:propertyType,handleChange:(e:string)=>dispatch(setPropertyType(e))},
    { name: "Price Range", placeholder: "Price Range",value:priceRange,data:PriceRange.map((item) => ({ value: item.value, label: item.label })),handleChange:(e:string)=>dispatch(setPriceRange(e)) },
    { name: "Status", placeholder: "Status",value:status,data:Object.keys(appStatus).map(key => ({ label: key, value: key })) ,handleChange:(e:string)=>dispatch(setStatus(e))},
    { name: "Sort Option", placeholder: "Sort Option" ,data: [{ label: "Newest", value: "newest" }, { label: "Oldest", value: "oldest" }],value:sort,handleChange:(e:string)=>dispatch(setSort(e))},
  ];
  

  const { classes } = styles();
  return (
    <Box className={classes.sort}>
      <Typography className={classes.search}>
        Search Available Properties
      </Typography>
      <Box className={classes.drop}>
{options.map((option, key) => {
  if (currentPage === "INVESTMENTS"&&option.name==="Price Range") return null;
  return (
    <Box className={classes.dropCont} key={key}>
      <Box>
        <Typography className={classes.selectName}>
          {option.name}
        </Typography>
        <InputSelect
          placeholder={option.placeholder}
          value={option.value}
          data={option.data}
          handleChange={(e) => option.handleChange(e.target.value)}
        />
      </Box>
      {key < options.length - 1 && (
        <Divider orientation="vertical" className={classes.divider} />
      )}
    </Box>
  );
})}
      
        <Button
          className={classes.btn}
          startIcon={<SearchIcon fontSize="large" />}
          variant="contained"
          onClick={()=>dispatch(setSearch(true))}
        >
          Search
        </Button>
      </Box>
    </Box>
  );
}
const styles = makeStyles()((theme) => ({
  sub: {
    flex: 1,
    height: "72%",
    width: "87%",
    borderTopRightRadius: pxToRem(8),
    borderBottomRightRadius: pxToRem(8),
    borderBottomLeftRadius: pxToRem(8),
    backgroundColor: AppColors.neutral["90"],
    [theme.breakpoints.down(1360)]: {
      width: "93%",
    },
  },
  search: {
    fontWeight: 400,
    fontSize: pxToRem(16),
    color: AppColors.text.second,
  },
  pagination: {
    padding: `0px ${pxToRem(AppSize.padding)}`,
    marginBottom: theme.spacing(4),
  },
  selectName: {
    fontSize: pxToRem(20),
    fontWeight: 500,
    color: AppColors.text.default,
    [theme.breakpoints.down(1360)]: {
      fontSize: pxToRem(18),
      fontWeight: 400,
    },
  },
  divider: {
    height: pxToRem(40),
    borderWidth: 1.7,
    borderStyle: "solid",
    borderColor: AppColors.neutral[85],
  },
  dropCont: {
    display: "flex",
    flexDirection: "row",
    gap: pxToRem(10),
    alignItems: "flex-end",
    justifyContent: "space-between",
  },
  drop: {
    display: "grid",
    gridTemplateColumns: "repeat(6,1fr)",
    gap: theme.spacing(4),
    [theme.breakpoints.down(1360)]: {
      gap: theme.spacing(2),
    },
  },
  btn: {
    height: pxToRem(46),
    borderRadius: pxToRem(8),
    width: pxToRem(150),
    alignSelf: "end",
    justifySelf: "end",
    [theme.breakpoints.down(1360)]: {
      width: pxToRem(100),
    },
  },
  sort: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    [theme.breakpoints.down(1360)]: {
      padding: theme.spacing(0), //cross check this padding
    },
  },
}));
